import { TENANT_BASE_URL } from './UrlHelper';

export const languages = 'admin/languages';
export const config = 'admin/settings-format';
export const notification_channels = 'admin/app/notification-channels';
export const app_general_settings = 'admin/app/settings';
export const mail_settings_list = 'admin/app/settings/delivery-settings';
export const brand_default_mail_settings = 'admin/brand/settings/delivery';
export const app_delivery_quotas = 'admin/app/delivery-quotas';
export const notification_setting = 'admin/app/notification-settings/';
export const notification_event_setting = 'admin/notification-events/settings/';
export const generateShortNames = 'admin/brands/generate-short-names';

export const brand_app_roles = 'admin/all-roles';
export const app_templates = 'admin/app/templates';
export const custom_fields = 'admin/app/custom-fields';
export const custom_field_types = 'admin/app/custom-field-types';
export const brand_privacy = 'admin/app/settings/brand-privacy';
export const statuses = 'admin/statuses';
export const subscriber_count = 'admin/app/subscribers-count';
export const campaign_count = 'admin/app/campaigns-count';
export const brand_count = 'admin/brands-count';
export const email_statics = 'admin/app/email-statistics';
export const logic_names = 'admin/logic-names';
export const logic_operators = 'admin/logic-operators';
export const app_updates = 'app/updates';
export const permissions = 'admin/auth/permissions';
export const sns_subscription = 'admin/sns-subscriptions';
export const check_mail_settings = 'admin/app/check-mail-settings';
export const mail_settings_view = '/admin/settings?tab=Delivery';
export const cron_job_settings = '/admin/app/settings/cronjob';
//Update
export const APP_UPDATE = `app/updates`;
export const APP_UPDATE_INSTALL = `app/updates/install`;
export const CLEAR_CACHE= `app/clear-cache`;
export const GET_UPDATE_URL = `app/generated-update-url-purchase-code`;

//Brand Urls
const brandPath = `brands/${window.hasOwnProperty('brand') ? window.brand?.short_name : ''}`;
export const brand_users = `${brandPath}/users`;
export const brand_user_invite = `${brandPath}/users/invite-user`;
export const brand_user_cancel_invitation = `${brandPath}/users/cancel-invitation`;
export const brand_roles = `${brandPath}/roles`;
export const brand_roles_select = `${brandPath}/roles/select`;
export const brand_attach_roles = `${brand_users}/attach-roles`;
export const brand_detach_roles = `${brand_users}/detach-roles`;
export const campaigns = `${brandPath}/campaigns`;
export const campaigns_create = `/${brandPath}/campaigns/create`;
export const subscribers = `/${brandPath}/subscribers`;
export const selectable_subscribers = `/${brandPath}/subscribers/select`;
export const subscribers_add_to_lists = `${subscribers}/add-to-lists`;
export const subscribers_remove_from_lists = `${subscribers}/remove-from-lists`;
export const subscribers_add_to_blacklist = `${subscribers}/add-to-blacklist`;
export const subscribers_bulk_destroy = `${subscribers}/bulk-destroy`;
export const subscribers_change_status = `${subscribers}/update-status`;
export const selectable_campaigns = `/${brandPath}/campaigns/select`;
export const selectable_list = `/${brandPath}/lists/select`;
export const subscriber_create = `/${brandPath}/subscribers/create`
export const subscriber_store = `${brandPath}/subscribers`
export const subscriber_view_imported = `${brandPath}/subscribers/view-imported`
export const subscriber_bulk_import = `/${brandPath}/subscribers/bulk-import`
export const subscriber_import = `/${brandPath}/subscribers/import`
export const subscriber_export = `/${brandPath}/subscribers/export`
export const list_create = `${brandPath}/lists/create`
export const lists = `${brandPath}/lists`;
export const lists_front_end = `${brandPath}/list/page`;
export const list_view = `${brandPath}/list`;
export const brand_templates = `${brandPath}/templates`;
export const brand_delivery_settings = `${brandPath}/settings/delivery`;
export const brand_delivery_settings_delete = `${brandPath}/settings/delivery/delete`;
export const brand_delivery_quotas = `${brandPath}/delivery-quotas`;
export const brand_delivery_provider = `${brandPath}/delivery/provider`;
export const brand_permissions = `${brandPath}/permissions`
export const brand_test_mail = `${brandPath}/test-mail/send`;
export const check_brand_mail_settings = `${brandPath}/check-mail-settings`;
export const brand_mail_settings_view = `${brandPath}/settings/page?tab=Delivery`;

export const subscribers_front_end = `${brandPath}/subscriber/list`;
export const campaigns_front_end = `${brandPath}/campaign/list`;
export const brand_subscriber_count = `${brandPath}/subscribers-count`;
export const brand_campaign_count = `${brandPath}/campaigns-count`;
export const brand_email_statics = `${brandPath}/email-statistics`;
export const brand_segment_count = `${brandPath}/segments-count`;
export const subscribers_count = `${brandPath}/subscribers/count`;

export const segments = `${brandPath}/segments`;
export const segments_front_end = `${brandPath}/segment`;
export const custom_field = `${brandPath}/custom-field`;

export const template_create = `/${brandPath}/templates/create`;
export const templates = `${brandPath}/templates`;
export const templates_card_view = `${brandPath}/template-card-view/list`;
export const templates_list_view = `${brandPath}/template-list-view/list`;

// SelectBox urls
export const select_segments_api = `${brandPath}/segments/select`;
export const select_subscribers_api = `${brandPath}/subscribers/select`;
export const brand_selectable_users = `${brandPath}/selectable-users`
export const brand_selectable_roles = `${brandPath}/selectable-roles`


export const email_logs = `${brandPath}/email-logs`;
export const email_log = `${brandPath}/email-log`;
export const user_brands = `admin/user/brands`;

export const brand_custom_field = `${brandPath}/settings/custom-fields`;
export const brand_sns_subscriptions = `${brandPath}/sns-subscriptions`;
export const brand_notification_settings = `${brandPath}/notification-settings`;
export const subscriber_api_url = `${brandPath}/get-subscriber-api-url`;

//Web Form
export const web_form_subscriber_create = `${brandPath}/web-form/subscriber`;
export const web_form_custom_field = `${brandPath}/web-form/get-custom-field`;

//Billar
export const MAIL_CHECK_URL = 'admin/app/check-mail-settings';
export const TENANT_MAIL_CHECK_URL = `admin/app/check-mail-settings`;
//Payment Methods
export const PAYMENT_METHOD = '/payment-method';
export const GET_PAYMENT_METHOD_STATUS = '/payment-method-status';
export const GET_STRIPE_STATUS = '/stripe-status';

//Reports
export const PAYMENT_SUMMARY_REPORT = '/reports/payment-summary';
export const INVOICE_REPORT = '/reports/invoice-report';
export const CLIENT_STATEMENT_REPORT = '/reports/client-statement-report';


//CRM
// Datatable Data - Global(Need to Modify)
export const DATATABLE_DATA ='';

//Recrutter
// Job Setting - Global
export const JOB_TYPE = `${TENANT_BASE_URL}app/job-type`;
export const DEPARTMENT = `${TENANT_BASE_URL}app/department`;
export const COMPANY_LOCATION = `${TENANT_BASE_URL}app/company-location`;
export const STAGE = `${TENANT_BASE_URL}app/stage`;
export const GLOBAL_APPLICATION_FORM = `${TENANT_BASE_URL}app/global/application-form`;
export const CAREER_PAGE = `${TENANT_BASE_URL}app/career-page`;

// Selectable Data - Global
export const SELECTABLE = `${TENANT_BASE_URL}app/selectable`;
export const SELECTABLE_JOBS = `${TENANT_BASE_URL}app/selectable/job-posts`;
export const SELECTABLE_DEPARTMENTS = `${TENANT_BASE_URL}app/selectable/departments`;
export const SELECTABLE_STAGES = `${TENANT_BASE_URL}app/selectable/stages`;
export const SELECTABLE_JOB_TYPES = `${TENANT_BASE_URL}app/selectable/job-types`;
export const SELECTABLE_COMPANY_LOCATIONS = `${TENANT_BASE_URL}app/selectable/company-locations`;
export const SELECTABLE_EVENT_TYPES = `${TENANT_BASE_URL}app/selectable/event-types`;

// Candidate or Applicant - Global
export const CANDIDATE = `${TENANT_BASE_URL}app/applicant`;
export const VERIFY_EMAIL = `${TENANT_BASE_URL}app/applicant/check-email`;

// Job Applicant - Applicant after applied job
export const JOB_APPLICANT = `${TENANT_BASE_URL}app/job-applicant`;

// Job
export const JOB = `${TENANT_BASE_URL}app/job-post`;
export const JOB_POST = `${TENANT_BASE_URL}app/job-post`;
export const JOB_STAGE = `${TENANT_BASE_URL}app/job-stage`;

// Dashboard
export const DASHBOARD = `${TENANT_BASE_URL}app/dashboard`;

// Events
export const EVENT = `${TENANT_BASE_URL}app/event`;
export const EVENT_TYPE = `app/event-type`;

// Todo
export const TODO = `${TENANT_BASE_URL}app/todo`;

// Notes
export const NOTE = `${TENANT_BASE_URL}app/note`;

// Hiring Team
export const HIRING_TEAM_LIST = `${TENANT_BASE_URL}app/get-teams-by-job`;
export const HIRING_TEAM = `${TENANT_BASE_URL}app/hiring-team/`;

//Social Sharable
export const SOCIAL_SHARABLE_THUMBNAIL = `${TENANT_BASE_URL}app/sharable_thumbnail`;

// Public Url
export const PUBLIC_JOB_POST = `${TENANT_BASE_URL}public/job-post`;
export const PUBLIC_VERIFY_EMAIL = `${TENANT_BASE_URL}public/candidate/check-email`;
export const PUBLIC_CAREER_PAGE = `${TENANT_BASE_URL}public/career`;


//Notification
export const NOTIFICATIONS = `${TENANT_BASE_URL}admin/user/notifications`;
export const NOTIFICATION_EVENTS = `${TENANT_BASE_URL}admin/app/notification-events`;
export const NOTIFICATION_TEMPLATES = `${TENANT_BASE_URL}admin/app/notification-templates`;

// Profile
export const MY_PROFILE = `${TENANT_BASE_URL}my-profile`;
export const All_NOTIFICATION = `${TENANT_BASE_URL}all-notifications`;
export const LOGOUT = `${TENANT_BASE_URL}admin/log-out`;

// app setting view
export const APP_SETTINGS = `${TENANT_BASE_URL}app-setting`;
export const GENERAL_SETTINGS = `${TENANT_BASE_URL}general-settings`;

// reCAPTCHA
export const GET_RECAPTCHA_SETTINGS = `${TENANT_BASE_URL}get-re-captcha-setting`;

// Sms settings
export const GET_SMS_SETTINGS_INFO = `${TENANT_BASE_URL}get-sms-setting-info`;

// Email settings
export const GET_EMAIL_SETTINGS = `${TENANT_BASE_URL}admin/app/settings/delivery-settings`;

// User and Roles
export const ROLES = `${TENANT_BASE_URL}admin/auth/roles`;
export const USERS = `${TENANT_BASE_URL}admin/auth/users`;
export const USERS_LIST = `${TENANT_BASE_URL}user-list`;
export const ALL_USERS = `${TENANT_BASE_URL}all-users`;
export const GET_USERS = `${TENANT_BASE_URL}get/users`;
export const GET_STATUSES = `${TENANT_BASE_URL}admin/app/statuses`;
export const INVITE_USER = `${TENANT_BASE_URL}admin/auth/users/invite-user`;
export const DETACH_ROLES = `${TENANT_BASE_URL}admin/auth/users/detach-roles/`;
export const UPDATE_USER_NAME = `${TENANT_BASE_URL}update-user-name/`;
export const LOGIN_USER = `${TENANT_BASE_URL}login-user`;

// Language
export const LANGUAGE = `${TENANT_BASE_URL}languages`;
export const BASIC_SETTINGS = `${TENANT_BASE_URL}get-basic-setting-data`;
export const LANG = `${TENANT_BASE_URL}lang`;

//Install
export const APP_LOG_IN = `${TENANT_BASE_URL}admin/users/login`;
export const GET_DATABASE_HOSTNAME = `${TENANT_BASE_URL}setup/get-database-hostname`;
export const SET_UP_EMAIL = `${TENANT_BASE_URL}setup/email-setup`;
export const SET_UP_BROADCAST = `${TENANT_BASE_URL}setup/broadcast-setup`;
export const BROADCAST_SETTING_UPDATE = `${TENANT_BASE_URL}setup/broadcast-setting-update`;
export const BROADCAST_SKIP = `${TENANT_BASE_URL}setup/broadcast-skip`;
export const EMAIL_SETUP_SKIP = `${TENANT_BASE_URL}setup/email-setup-skip`;
export const ADDITIONAL_REQUIREMENTS = `${TENANT_BASE_URL}setup/additional-requirements`;
export const ADDITIONAL_REQUIREMENT = `${TENANT_BASE_URL}setup/additional-requirement`;
export const DATABASE_CONFIGURATION = `${TENANT_BASE_URL}setup/database`;
export const PURCHASE_CODE= `${TENANT_BASE_URL}setup/purchase-code`;
export const PURCHASE_CODE_STORE= `${TENANT_BASE_URL}setup/purchase-code-store`;
export const INSTALL= `${TENANT_BASE_URL}install`;
export const EMAIL_SETTING_UPDATE= `${TENANT_BASE_URL}setup/email-setting-update-delivery`;
export const TEST_MAIL= `${TENANT_BASE_URL}app/test-mail/send`;
export const test_mail_mailer = 'admin/app/test-mail-mailer/send';
export const CRON_JOB_SETTING= `${TENANT_BASE_URL}admin/app/settings/cronjob`;
export const MAIL_SETUP_CHECK_URL = `${TENANT_BASE_URL}check-mail-settings`;
export const JOB_POINT_EMAIL_SETUP_SETTING = `${TENANT_BASE_URL}app-setting?tab=Email%20Setup`;
export const NOTIFICATION_SETTINGS_FRONT_END = `${TENANT_BASE_URL}app-setting?tab=Notification`;
export const CANCEL_INVITATION = `${TENANT_BASE_URL}cancel-invitation`;
export const GET_ZOOM_SETTINGS = `${TENANT_BASE_URL}admin/app/meeting/zoom-setting`;
export const GET_IMAP_SETTINGS = `${TENANT_BASE_URL}admin/app/imap/imap-setting`;
export const IMAP_SETTING = `${TENANT_BASE_URL}app-setting?tab=Imap%20settings`;
